import gql from 'graphql-tag';

export const FREIGHT_OFFER_MUTATION = gql`
  mutation upsertOffer(
    $offers: [UpsertShippingRoute!]
    $freightRequestId: ID!
    $ship: InputShip
  ) {
    upsertFreightOffer(
      freightRequestId: $freightRequestId
      routes: $offers
      ship: $ship
    ) {
      freightRequestId
      company {
        companyName
      }
      details {
        layDate
        cancelling
        offerWithin
        offerValidTo
        offerSubsDue
      }
      cargo {
        cargoName
        quantity {
          unit
          amount
          tolerance
        }
      }
      routes {
        routeId
        addId
        loadLocations {
          locationName
          locationCode
        }
        dischargeLocations {
          locationName
          locationCode
        }
        loadComment
        dischargeComment
        offer {
          offerAmount
          offerUnit
          offerComment
        }
      }
      ship {
        id
        name
        laytimeHours
        overage
        demurrageRate
        comments
      }
      requirements {
        subject
        type
        details {
          reference
          description
        }
      }
      documents {
        documentName
        documentUrl
      }
      subTerms {
        description
        amendments {
          reference
          description
        }
      }
      conditions
      status
      modified
      created
    }
  }
`;
